import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=13961d9a"
import script from "./Answer.vue?vue&type=script&lang=ts"
export * from "./Answer.vue?vue&type=script&lang=ts"
import style0 from "./Answer.vue?vue&type=style&index=0&id=13961d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports